import { BaseCameraScanner } from "./BaseCameraScanner";
import { IScannerCode } from "./Abstraction/IScanner";
import { loadScriptAsync } from "../Utils";

declare global {

    const mwbScanner: typeof import("cmbsdk-cmbweb").default;
}

export class CognexScanner extends BaseCameraScanner {

    protected _libPath: string;

    constructor(libPath: string) {
        super();
        this._libPath = libPath;
    }

    /**************************************/

    scanSingleAsync() {
        return new Promise<IScannerCode|null>((res, rej) => {

            mwbScanner.startScanning(result => {

                if (result.type == "Cancel")
                    res(null);

                else {
                    res({
                        type: result.type,
                        code: result.code
                    });
                }
            });
        });
    }

    /**************************************/

    async stopScanAsync() {

    }

    /**************************************/

    protected getVideoWork() {
        return document.getElementById("video-layer") as HTMLVideoElement;
    }

    /**************************************/

    protected async openWorkAsync() {

        if (!("mwbScanner" in window)) {
            await loadScriptAsync(this._libPath + "cmbweb.js");
        }
        mwbScanner.set_scannerConfig(() => this.scannerConfig());
        this.scannerConfig();
    }

    /**************************************/

    async setCameraAsync(index: number) {

        mwbScanner.setCamera(this._cameras[index].deviceId);
    }

    /**************************************/

    protected async scannerConfig() {

        console.log('scannerConfig called');

        const consts = mwbScanner.getConstants();

        await mwbScanner.loadSettings([
            {
                method: "MWBsetActiveCodes", value:
                    [
                        consts.MWB_CODE_MASK_QR |
                        consts.MWB_CODE_MASK_DM |
                        consts.MWB_CODE_MASK_EANUPC |
                        consts.MWB_CODE_MASK_EANUPC |
                        consts.MWB_CODE_MASK_128 |
                        consts.MWB_CODE_MASK_PDF
                    ]
            }
        ]);
    }
}


document.addEventListener("cameraReady", ev => {
    console.log("cameraReady");
});

document.addEventListener("scannerModuleLoaded", ev => {
    console.log("scannerModuleLoaded");
});

document.addEventListener("preScannerModuleLoaded", async ev => {

    console.log("preScannerModuleLoaded");

    mwbScanner.setIcon("/assets/licence.png");
});